import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import TypeEquipment from './type'
import UnitEquipment from './unit'

function EquipmentBudgetIndex() {
  return (
    <>
        <TextMediumSM content="Budget" />
        <TextMediumSM content="Equipment" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <TypeEquipment/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <UnitEquipment/>
         </div>
         </div>
         </>
  )
}

export default EquipmentBudgetIndex
